/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useTranslation } from "react-i18next";
import logoArabic from "../../../assets/logoArabic.png";
import logoEnglish from "../../../assets/logoEnglish.png";
import { COLORS } from "./footer.constants";

export default function FooterBrand() {
  const { t, i18n } = useTranslation();
  const isAR = i18n.language === "ar";

  return (
    <div className="col-12 col-md-4 mb-4 d-flex flex-column align-items-center align-items-md-start">
      <img
        src={isAR ? logoArabic : logoEnglish}
        alt="Madar"
        style={{ height: "65px", marginTop: "-10px" }}
      />

      <p
        style={{
          color: COLORS.textLight,
          lineHeight: 1.9,
          margin: 0,
          maxWidth: 360,
          fontSize: "1rem",
          opacity: 0.9,
        }}
      >
        {t("footer.description")}
      </p>
    </div>
  );
}
